<div class="watch-now-block">
    <div class="watch-now-row">
        <img src="assets/common/images/header/Green_Star.png"
             class="star" (click)="onWatchNow()" />
        <img src="assets/common/images/header/Arrow2.png"
             class="watch-now-arrow" />
        <img src="assets/common/images/header/CLICK_HERE___Lexend_.png"
             class="click-here" />
    </div>
</div>

<div class="modal-overlay" *ngIf="isModalOpen" (click)="closeModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
        <iframe width="480"
                height="270"
                [src]="youtubeUrl"
                frameborder="0"
                allowfullscreen
                allow="autoplay; encrypted-media">
        </iframe>
        <button class="modal-close" (click)="closeModal()"><span>&times;</span></button>
    </div>
</div>
